export default __webpack_public_path__ + "static/media/ms_implement_iconbox.1de43382.svg";